import React from "react";

function sanitizeId(id) {
  return String(id).replace(/[^a-zA-Z0-9_-]/g, "_");
}

/** 向上三层渐变箭头（返佣方向） */
export function ArrowUpTriple({ className }) {
  const uid = sanitizeId(React.useId());
  const gradId = `paint0_linear_up_${uid}`;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="33"
      viewBox="0 0 16 33"
      fill="none"
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.52814 22.167C7.07749 22.167 6.64993 22.3696 6.36506 22.7188L0.337715 30.1074C-0.185699 30.7492 -0.0899973 31.6941 0.551582 32.2178C1.19341 32.7411 2.13829 32.6455 2.66193 32.0039L7.52814 26.04L12.3934 32.0039C12.9171 32.6455 13.8619 32.7412 14.5037 32.2178C15.1454 31.6942 15.2409 30.7493 14.7176 30.1074L8.69025 22.7188L8.57697 22.5947C8.2984 22.3221 7.92229 22.1671 7.52814 22.167ZM7.52814 14.7773C7.07761 14.7773 6.64993 14.9801 6.36506 15.3291L0.337715 22.7178C-0.185843 23.3596 -0.089963 24.3044 0.551582 24.8281C1.19347 25.3518 2.13825 25.2561 2.66193 24.6143L7.52814 18.6504L12.3934 24.6143C12.9171 25.2562 13.8618 25.3518 14.5037 24.8281C15.1452 24.3044 15.2411 23.3595 14.7176 22.7178L8.69025 15.3291L8.57697 15.2051C8.29842 14.9325 7.92223 14.7775 7.52814 14.7773ZM7.52814 7.38867C7.07756 7.38867 6.64993 7.59134 6.36506 7.94043L0.337715 15.3291C-0.185868 15.9709 -0.0900478 16.9157 0.551582 17.4395C1.19347 17.9631 2.13825 17.8674 2.66193 17.2256L7.52814 11.2617L12.3934 17.2256C12.9171 17.8675 13.8618 17.9631 14.5037 17.4395C15.1453 16.9157 15.2412 15.9709 14.7176 15.3291L8.69025 7.94043L8.57697 7.81641C8.29841 7.5438 7.92228 7.38881 7.52814 7.38867ZM7.52814 0C7.07751 0 6.64993 0.202595 6.36506 0.551758L0.337715 7.94043C-0.185873 8.58225 -0.0900602 9.52706 0.551582 10.0508C1.19347 10.5744 2.13827 10.4787 2.66193 9.83691L7.52814 3.87305L12.3934 9.83691C12.9171 10.4788 13.8618 10.5744 14.5037 10.0508C15.1454 9.52708 15.2411 8.58225 14.7176 7.94043L8.69025 0.551758L8.57697 0.427734C8.2984 0.155115 7.92229 0.000139757 7.52814 0Z"
        fill={`url(#${gradId})`}
      />
      <defs>
        <linearGradient
          id={gradId}
          x1="7.5277"
          y1="1.45771"
          x2="7.5277"
          y2="32.5554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C1FF45" />
          <stop offset="1" stopColor="#C1FF45" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

/** 向下三层渐变箭头（邀请方向） */
export function ArrowDownTriple({ className }) {
  const uid = sanitizeId(React.useId());
  const gradId = `paint0_linear_down_${uid}`;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="33"
      viewBox="0 0 16 33"
      fill="none"
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.52814 10.3884C7.07749 10.3884 6.64993 10.1859 6.36506 9.83667L0.337715 2.448C-0.185699 1.80618 -0.0899973 0.861315 0.551582 0.337646C1.19341 -0.185699 2.13829 -0.0900688 2.66193 0.551514L7.52814 6.51538L12.3934 0.551514C12.9171 -0.0900764 13.8619 -0.185818 14.5037 0.337646C15.1454 0.861269 15.2409 1.80616 14.7176 2.448L8.69025 9.83667L8.57697 9.96069C8.2984 10.2333 7.92229 10.3883 7.52814 10.3884ZM7.52814 17.7781C7.07761 17.7781 6.64993 17.5753 6.36506 17.2263L0.337715 9.83765C-0.185843 9.19587 -0.089963 8.25103 0.551582 7.72729C1.19347 7.20365 2.13825 7.29931 2.66193 7.94116L7.52814 13.905L12.3934 7.94116C12.9171 7.29925 13.8618 7.20363 14.5037 7.72729C15.1452 8.25104 15.2411 9.19588 14.7176 9.83765L8.69025 17.2263L8.57697 17.3503C8.29842 17.6229 7.92223 17.7779 7.52814 17.7781ZM7.52814 25.1667C7.07756 25.1667 6.64993 24.9641 6.36506 24.615L0.337715 17.2263C-0.185868 16.5845 -0.0900478 15.6397 0.551582 15.116C1.19347 14.5923 2.13825 14.688 2.66193 15.3298L7.52814 21.2937L12.3934 15.3298C12.9171 14.6879 13.8618 14.5923 14.5037 15.116C15.1453 15.6397 15.2412 16.5845 14.7176 17.2263L8.69025 24.615L8.57697 24.739C8.29841 25.0116 7.92228 25.1666 7.52814 25.1667ZM7.52814 32.5554C7.07751 32.5554 6.64993 32.3528 6.36506 32.0037L0.337715 24.615C-0.185873 23.9732 -0.0900602 23.0284 0.551582 22.5046C1.19347 21.9811 2.13827 22.0767 2.66193 22.7185L7.52814 28.6824L12.3934 22.7185C12.9171 22.0767 13.8618 21.981 14.5037 22.5046C15.1454 23.0283 15.2411 23.9732 14.7176 24.615L8.69025 32.0037L8.57697 32.1277C8.2984 32.4003 7.92229 32.5553 7.52814 32.5554Z"
        fill={`url(#${gradId})`}
      />
      <defs>
        <linearGradient
          id={gradId}
          x1="7.5277"
          y1="31.0977"
          x2="7.5277"
          y2="-1.14441e-05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C1FF45" />
          <stop offset="1" stopColor="#C1FF45" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
